import {
	Environment,
	Network,
	RecordSource,
	Store,
	commitLocalUpdate,
	QueryResponseCache
} from "relay-runtime";

const oneMinute = 1000 * 60;
const cache = new QueryResponseCache({ size: 250, ttl: oneMinute });

const { REACT_APP_GRAPHQL_API } = process.env;

// Implement the cache strategey bellow:
function fetchQuery(operation, variables, cacheConfig) {
	const queryID = operation.text;
	const isMutation = operation.operationKind === "mutation";
	const isQuery = operation.operationKind === "query";
	const forceFetch = cacheConfig && cacheConfig.force;

	// Try to get data from cache on queries
	const fromCache = cache.get(queryID, variables);
	if (isQuery && fromCache !== null && !forceFetch) {
		return fromCache;
	}

	// Otherwise fetch data from the server
	return fetch(REACT_APP_GRAPHQL_API, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			// "Authorization": `JWT ${localStorage.getItem(GC_AUTH_TOKEN)}` 
		},
		body: JSON.stringify({
			query: operation.text,
			variables
		})
	}).then(response => {
		return response.json();
	});
}

const environment = new Environment({
	network: Network.create(fetchQuery),
	store: new Store(new RecordSource())
});

function getInitialValue(key, value) {
	try {
		const storedValue = window.localStorage.getItem(key);
		return !storedValue ? value : JSON.parse(storedValue);
	} catch (error) {
		return value;
	}
}

commitLocalUpdate(environment, store => {
	const fieldKey = "settings";
	const __typename = "Settings";
	const random_string = "zjylsvnkhftiyctawfhhhwdszdvhglxr";

	const dataID = `client:${__typename}`;
	const record = store.create(dataID, __typename);

	const navInitialValue = getInitialValue("Settings.isNavActivated", true);
	record.setValue(navInitialValue, "isNavActivated");

	const fullScreenMenuInitialValue = getInitialValue("Settings.isFullScreenMenuActivated", false);
	record.setValue(fullScreenMenuInitialValue, "isFullScreenMenuActivated");
	
	const noteNavInitialValue = getInitialValue("Settings.isNoteNavActivated", false);
	record.setValue(noteNavInitialValue, "isNoteNavActivated");

	const noteviewInitialValue = getInitialValue("Settings.isNoteViewActivated", false);
	record.setValue(noteviewInitialValue, "isNoteViewActivated");

	const treeInitialValue = getInitialValue("Settings.treeStates", "{}");
	record.setValue(treeInitialValue, "treeStates");

	const viewInitialValue = getInitialValue("Settings.view", "grid");
	record.setValue(viewInitialValue, "view");


	const metaInitialValue = getInitialValue("Settings.metaDescription", "Articles from");
	record.setValue(metaInitialValue, "metaDescription");

	const metaSourceInitailValue = getInitialValue("Settings.metaSourceName", "All Subscriptions");
	record.setValue(metaSourceInitailValue, "metaSourceName");

	record.setValue(false, "isAuthenticated");
	record.setValue("{}","tagData");
	record.setValue("{}","sentimentPostIdData");
	record.setValue('', "userId");
	record.setValue([""], "selectedSourceId");
	record.setValue('', "selectedParentId");
	record.setValue(true, "isParent");
	record.setValue([""], "selectedNodeId");
	record.setValue('', "selectedPostId");
	record.setValue([], "selectedSentimentPostIds");

	record.setValue(random_string, "sourceString");

	record.setValue([], "selectedLeads");
	record.setValue([], "filterTerms");
	record.setValue(false, "isDetailView");
	record.setValue(false, "isBookmarkView");
	record.setValue(false, "isPostNoteView");
	record.setValue(false, "isNewFolderView");
	record.setValue(false, "isFullScreenAddSouceModalActivated");
	record.setValue(false, "isFullSpanSearchModalActivated");
	record.setValue(false, "isFullSpanNoteModalActivated");
	record.setValue(false, "isFullSpanSourceSearchModalActivated");
	record.setValue(false, "isFullSpanShareModalActivated");
	record.setValue(false, "isFullSpanInputModalActivated");
	record.setValue(false, "isProductDemoActivated");
	record.setValue(false, "isAnalyseModalActivated");

	record.setValue('0', "scrollPosition");
	record.setValue(false, "isHomeReturn");
	const cat_world = "Q2F0ZWdvcnlOb2RlOjE=";
	record.setValue(cat_world, "categoryId");

	record.setValue('', "hasPhrase");
	record.setValue('', "withoutWords");
	record.setValue('', "withWords");
	record.setValue('', "searchScope");
	record.setValue('', "searchTime");
	record.setValue(false, "isAdvancedSearch");
	record.setValue(true, "allSubscriptions");

	record.setValue(false, "isSubListView");
	record.setValue(false, "isProfileView");
	record.setValue(false, "isAccountView");

	record.setValue(false, "isAddSourceModalActivated");
	record.setValue(false, "isAddSourcePageActivated");
	record.setValue(false, "isAddFeedBoxShown");

	record.setValue('', "selectedSubId");
	record.setValue('', "selectedSubName");
	record.setValue(false, "isRightNavActivated");
	record.setValue(["-created"], "order");
	record.setValue('', "selectedAnayzeTitle");
	record.setValue('', "selectedAnalyzePostId");

	environment.retain({
		request: {},
		root: {
			dataID,
			variables: {},
			node: { selections: [] }
		}
	});

	store.getRoot().setLinkedRecord(record, fieldKey);
});

export function updateLocalSetting(key, value) {
	commitLocalUpdate(environment, store => {
		const record = store.getRoot().getLinkedRecord("settings");
		window.localStorage.setItem(`Settings.${key}`, JSON.stringify(value));
		record.setValue(value, key);
	});
}

export default environment;
